<template>
    <section class="header-none"></section>
</template>

<script setup>
defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-header-none";
</style>
